module.exports = __webpack_public_path__ + "10.png?f6a9ab0b8549a64834be24dbf55c7bbf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/10.png
// module id = 124
// module chunks = 3